import { useEffect } from 'react'
import { leaveOnlineQueue } from '../games/colorful/api/online'

/**
 * Hard cap on how long a player may sit in the matchmaking queue. The
 * server already expires abandoned queue spots and stale lobbies, but a
 * client that's actively polling would otherwise keep its spot alive
 * forever — this pulls the local player out after an hour so they're not
 * stuck on a "finding a match…" screen indefinitely.
 */
export const MATCHMAKING_TIMEOUT_MS = 60 * 60 * 1000 // 60 minutes

export function useMatchmakingTimeout(
  gameType: 'ideatthat' | 'colorful' | 'three_step',
  active: boolean,
  onTimeout: () => void,
) {
  useEffect(() => {
    if (!active) return
    const t = setTimeout(async () => {
      try { await leaveOnlineQueue(gameType) } catch { /* best effort */ }
      onTimeout()
    }, MATCHMAKING_TIMEOUT_MS)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, gameType])
}
